import React, { Component } from 'react';

export default class SlideDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }


  render() {
    return (
      <div className="carousel-component-block carousel-component-block-pdf">
        <div className="large-12 medium-12 small-12 columns">{this.props.children}</div>
      </div>
    );
  }
}

